import { Component, Input, OnInit } from '@angular/core';
import { DataService } from '../data/data.service';
import { ActivityReportDay, DailyActivityReport } from '../data/daily-activity-report';
import { EmailSubscriptionSetting } from '../data/email-subscriptions';
import { FormatUtilities } from '../utilities/format-utilities';

@Component({
  selector: 'app-class-weekly-report',
  templateUrl: './class-weekly-report.component.html',
  styleUrls: ['./class-weekly-report.component.scss']
})
export class ClassWeeklyReportComponent implements OnInit {

  monthNames = FormatUtilities.monthNames;

  constructor(protected dataService: DataService) { }

  @Input() organizationID: number;
  @Input() classID: number;
  @Input() teacherID: number;

  circleReport: DailyActivityReport[];
  weekStart: Date;
  weekEnd: Date;
  weekDays: Date[];
  cutoffIndex: number;
  sessionLength: number;
  showMinutes: boolean = false;
  subscriptionSettings: EmailSubscriptionSetting[];
  changingSubscription: boolean = false;

  ngOnInit() {
    this.getCircleReport();
    this.getSubscriptions();
  }

  getCircleReport(): void {
    this.weekStart = new Date();
    this.cutoffIndex = this.weekStart.getDay();
    this.weekStart.setDate(this.weekStart.getDate() - this.cutoffIndex);
    this.weekStart.setHours(0, 0, 0, 0);

    this.weekEnd = new Date(this.weekStart.getTime());
    this.weekEnd.setDate(this.weekEnd.getDate() + 6);

    this.updateCircleReport();
    this.dataService.getClassUsageLimits(this.classID).subscribe(r => {
      if (!r || !r.DailyActivityLimit) this.sessionLength = 10; // Default
      else if (r.DailyActivityLimit > 10) this.sessionLength = 10; // Maximum
      else this.sessionLength = r.DailyActivityLimit;
    })
  }

  updateCircleReport(): void {
    this.updateWeekDays();
    this.dataService.getDailyActivityReport(this.classID, this.weekStart, 7).subscribe(r => {
      this.circleReport = r.sort((a,b) => {
        if ( a.Name.toLocaleLowerCase() < b.Name.toLocaleLowerCase() ){
          return -1;
        }
        if ( a.Name.toLocaleLowerCase() > b.Name.toLocaleLowerCase() ){
          return 1;
        }
        return 0;
      });
    });
  }

  updateWeekDays(): void {
    this.weekDays = [];

    for (let index = 0; index < 7; index++) {
      this.weekDays.push(this.getOffsetDate(index));
    }
  }

  getSubscriptions(): void {
    // const roleCode = localStorage.getItem('roleCode'); 
    // if (roleCode !== 'Super' && roleCode !== 'Teacher') return;

    this.dataService.getClassEmailSubscriptionSettings(this.classID).subscribe(settings => {
      if (settings !== undefined || settings.length > 0) {
        this.subscriptionSettings = settings;
        return;
      }
    });
  }

  updateSubscription(subscription: EmailSubscriptionSetting): void {
    this.changingSubscription = true;
    console.log(subscription);
    this.dataService.setEmailSubscription(subscription.TeacherAccountID, subscription).subscribe(s => {
      this.changingSubscription = false;
    },
    err => {
      subscription.IsOptedIn = !subscription.IsOptedIn;
      this.changingSubscription = false;
    });
  }

  getVisibility(day: ActivityReportDay): string {
    if (day.DayIndex > this.cutoffIndex) return "hidden";
    else return "";
  }

  getActivityClass(day: ActivityReportDay): string {
    if (day.Activities >= this.sessionLength) return "complete-session";
    else if (day.Activities > 0) return "partial-session";
    else return "no-session";
  }

  previousWeek() {
    var today = new Date();
    this.weekStart.setDate(this.weekStart.getDate() - 7);
    this.weekEnd.setDate(this.weekEnd.getDate() - 7);
    
    if (today < this.weekEnd) {
      this.cutoffIndex = today.getDay();
    }
    else {
      this.cutoffIndex = 7;
    }

    this.updateCircleReport();
  }

  nextWeek() {
    var today = new Date();
    this.weekStart.setDate(this.weekStart.getDate() + 7);
    this.weekEnd.setDate(this.weekEnd.getDate() + 7);

    if (today < this.weekEnd) {
      this.cutoffIndex = today.getDay();
    }
    else {
      this.cutoffIndex = 7;
    }
    this.updateCircleReport();
  }

  secondsToMinutes(seconds: number): string {
    var minutes = Math.round(seconds / 60);
    return `${minutes} min`;
  }

  getShortMonth(date: Date): string {
    return this.monthNames[date.getUTCMonth()].toUpperCase();
  }

  getOffsetDate(offset?: number): Date {
    if (!offset) offset = 0;

    var offsetDate : Date;
    if (!this.weekStart.getTime){
      offsetDate = new Date(this.weekStart);
    }
    else offsetDate = new Date(this.weekStart.getTime());

    offsetDate.setDate(offsetDate.getDate() + offset);
    return offsetDate;
  }

}
